import { Link } from "gatsby"
import React from "react"
import { Button, Col, Container, Row } from "shards-react"
import Image from "../components/image"
import KnowMoreInput from "../components/KnowMoreInput"
import Banner from "../containers/Banner"
import CallToAction from "../containers/CallToAction"
/* import { Link } from "gatsby" */
import Layout from "../containers/Layout"
import Navbar from "../containers/Navbar"
import SEO from "../containers/Seo"

const IndexPage = () => (
  <Layout>
    <SEO title="Samus" />
    <Banner>
      <Navbar />
      <Row
        data-sal="slide-up"
        data-sal-delay="150"
        data-sal-easing="ease"
        className="text-center pt-4"
      >
        <Col>
          <h1 className="text-white main-text">
            <b>¿Listo para mejorar la Educación?</b>
          </h1>
        </Col>
      </Row>
      <Row
        data-sal="slide-up"
        data-sal-delay="300"
        data-sal-easing="ease"
        className="text-center text-white p-5"
      >
        <Col>
          <p className="mb-2">
            Empieza a utilizar el primer sistema de{" "}
            <b>Educación Tecnológica Integrada</b> para mejorar la gestión
            educativa, de forma segura y confiable.
          </p>
          <p>
            Registra tu correo electrónico para saber más de como podemos
            cambiar la calidad de la educación en nuestro pais.
          </p>
        </Col>
      </Row>
      <Row data-sal="slide-up" data-sal-delay="300" data-sal-easing="ease">
        <Col className="d-none d-md-flex d-lg-flex d-xl-flex">
          <KnowMoreInput />
        </Col>
      </Row>
      <Row className="mt-5">
        <Col>
          <div className="main-image">
            {" "}
            <Image file="dashboard_img.png" />
          </div>
        </Col>
      </Row>
    </Banner>

    <Container fluid>
      <hr className=" m-5 separator d-none d-md-block d-lg-block d-xl-block" />
      <section className="mt-5 mx-3 mb-3 pt-5">
        <Row
          data-sal="slide-up"
          data-sal-delay="300"
          data-sal-easing="ease"
          className="call-to-action"
        >
          <Col className="mt-5">
            <h3>Sistema de Gestión Escolar</h3>
            <p className="m-0">
              El <b>Proyecto Samus</b> es una solución de gestión escolar basada
              en la nube
            </p>
            <p className="m-0">
              que ayuda a conectar a profesores, alumnos y padres a través de
              una única interfaz.
            </p>
          </Col>
        </Row>
        <br />
        <Row className="m-5">
          <Col
            data-sal="slide-up"
            data-sal-delay="300"
            data-sal-easing="ease"
            xs="12"
            sm="4"
          >
            <Row>
              <Col>
                <div className="icon-container">
                  <Image file="school_managment.png" />
                </div>
              </Col>
            </Row>
            <Row className="text-center">
              <Col>
                <h5>Administración Escolar</h5>
              </Col>
            </Row>
            <Row className="text-center">
              <Col>
                <p>
                  Nos permite realizar tareas como inscripción, registro de
                  factura, personalización de manera rapida y sencilla.
                </p>
              </Col>
            </Row>
          </Col>

          <Col
            data-sal="slide-up"
            data-sal-delay="300"
            data-sal-easing="ease"
            xs="12"
            sm="4"
          >
            <Row>
              <Col>
                <div className="icon-container">
                  <Image file="future_tech.png" />
                </div>
              </Col>
            </Row>
            <Row className="text-center">
              <Col>
                <h5>Tecnologia con mira al futuro</h5>
              </Col>
            </Row>
            <Row className="text-center">
              <Col>
                <p>
                  Utilizamos las mejores Tecnologias para contar con un
                  rendimiento y seguridad excepcional. Todo basado en servicios
                  en la nube <i>(asi como Amazon, Google y Microsotf)</i>.
                </p>
              </Col>
            </Row>
          </Col>

          <Col
            data-sal="slide-up"
            data-sal-delay="300"
            data-sal-easing="ease"
            xs="12"
            sm="4"
          >
            <Row>
              <Col>
                <div className="icon-container">
                  <Image file="reality_adapted.png" />
                </div>
              </Col>
            </Row>
            <Row className="text-center">
              <Col>
                <h5>Adaptado a nuestra realidad</h5>
              </Col>
            </Row>
            <Row className="text-center">
              <Col>
                <p>
                  El software fue creado para soportar todo tipo de
                  instituciones educativas dominicanas, sin importar su tamaño.
                </p>
              </Col>
            </Row>
          </Col>
        </Row>
      </section>
    </Container>
    <Container>
      <section
        data-sal="slide-up"
        data-sal-delay="300"
        data-sal-easing="ease"
        className="m-3 pt-5"
      >
        <Row className="call-to-action">
          <Col>
            <h3>
              Mejora la calidad con <b>Educación Colaborativa</b>
            </h3>
            <p className="m-0">
              Para mejorar la educación no podremos hacerlo solos, ni siquiera
              agregando un sistema.
            </p>
            <p className="m-0">
              {" "}
              Para eso necesitamos la ayuda de los <b>Padres y/o Tutores</b>.
            </p>
          </Col>
        </Row>
        <br />
      </section>
      <br></br>

      <section className="m-3 pt-5">
        <Row
          data-sal="slide-left"
          data-sal-duration="400"
          data-sal-delay="250"
          data-sal-easing="ease"
          className="mb-5"
        >
          <Col className="d-none d-sm-block">
            <Image file="join-family.png" />
          </Col>
          <Col>
            <Row>
              <Col>
                <h4>Para Padres</h4>
              </Col>
            </Row>
            <Row>
              <Col>
                <p>
                  Poder monitorear las calificaciónes, asistencias y
                  observaciones de sus hijos por una aplicación movíl. Asi
                  ayudar a sus hijos ante cualquier situación.
                </p>
              </Col>
            </Row>
            <Row className="mt-3">
              <Col>
                <Link to="como-funciona#padres">
                  <Button outline>Leer más</Button>
                </Link>
              </Col>
            </Row>
          </Col>
        </Row>
        <br></br>
        <Row
          data-sal="slide-right"
          data-sal-duration="400"
          data-sal-delay="250"
          data-sal-easing="ease"
          className="no-sx-m-5 "
        >
          <Col className="p-0">
            <Row>
              <Col>
                <h4>Para Docentes</h4>
              </Col>
            </Row>
            <Row>
              <Col>
                <p>
                  Contar con el apoyo de los padres y tener un canal de
                  comunicación directo, hará más eficiente el proceso de
                  enseñanza.
                </p>
              </Col>
            </Row>
            <Row className="mt-3">
              <Col>
                <Link to="como-funciona#profesores">
                  <Button outline>Leer más</Button>
                </Link>
              </Col>
            </Row>
          </Col>
          <Col className="d-none d-sm-block">
            <Image file="teacher-working.png" />
          </Col>
        </Row>
        <br /> <br />
        <Row
          data-sal="slide-left"
          data-sal-duration="400"
          data-sal-delay="250"
          data-sal-easing="ease"
          className="mb-5"
        >
          <Col className="d-none d-sm-block px-5">
            <Image file="principal-thinking.png" />
          </Col>
          <Col>
            <Row>
              <Col>
                <h4>Para Directores</h4>
              </Col>
            </Row>
            <Row>
              <Col>
                <p>
                  Con un manejo todo los datos y reportes podran tomar
                  desiciones y crear estrategias que velarán a favor de la
                  calidad de su institución
                </p>
              </Col>
            </Row>
            <Row className="mt-3">
              <Col>
                <Link to="como-funciona#directores">
                  <Button outline>Leer más</Button>
                </Link>
              </Col>
            </Row>
          </Col>
        </Row>
      </section>
    </Container>

    <CallToAction />
  </Layout>
)

export default IndexPage
